export const getPercentageValue = (percentageValue: number) =>
  Math.min(100, Math.max(0, percentageValue));
